module.exports = __webpack_public_path__ + "static/img/Asia_normal@2x.d5ebe0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/Asia_normal@2x.png
// module id = 574
// module chunks = 0